<script setup>
import { onClickOutside } from "@vueuse/core";
const route = useRoute();
const isShowSort = ref(false);
const refDropdown = ref(false);

const sortOptions = ref([
  {
    name: "Сначала недорогие",
    sort: "cheap",
  },
  {
    name: "Сначала дорогие",
    sort: "expensive",
  },
]);

const selectValue = ref(sortOptions.value[0]);

watch(selectValue, () => {
  isShowSort.value = false;
});

onClickOutside(refDropdown, () => {
  isShowSort.value = false;
});

const mode = computed(() => route.query?.mode ?? "tile");

const emit = defineEmits(["change-mode", "change-sort"]);

function changeMode(value) {
  emit("change-mode", value);
}

watch(selectValue, () => {
  emit("change-sort", selectValue.value);
});
</script>

<template>
  <div
    class="w-full hidden lg:flex rounded-lg px-3 py-3.5 bg-white h-10 flex-row justify-between items-center"
    style="box-shadow: 0px 4px 20px 0px #48507029"
  >
    <div class="flex flex-row items-center space-x-5">
      <p class="font-lato text-sm">Сортировать</p>
      <div class="relative">
        <div
          @click="isShowSort = !isShowSort"
          class="font-lato relative text-sm flex flex-row space-x-2 items-center cursor-pointer"
          :class="isShowSort ? 'text-secondary-200' : 'text-primary-200'"
        >
          <p>{{ selectValue.name }}</p>
          <p-icon-arrow
            class="w-3 h-3"
            :isOpen="isShowSort"
            :color="isShowSort ? '#FFA267' : '#656F9C'"
          ></p-icon-arrow>
        </div>
        <p-dropdown-wrapper
          v-if="isShowSort"
          ref="refDropdown"
          class="absolute top-8 rounded-lg !w-50 right-0 z-40"
        >
          <ul
            v-for="option in sortOptions"
            key="option.name"
            class="mb-2 last:mb-0"
          >
            <li class="flex items-center whitespace-nowrap space-x-2">
              <input
                type="radio"
                class="cursor-pointer accent-[#3a405a]"
                :id="option.sort"
                :value="option"
                v-model="selectValue"
              />
              <label
                @click="selectValue = option"
                class="cursor-pointer font-lato text-sm text-gray-700"
                >{{ option.name }}</label
              >
            </li>
          </ul>
        </p-dropdown-wrapper>
      </div>
    </div>
    <div class="flex flex-row space-x-4">
      <p-icon-menu
        class="w-5 h-5 cursor-pointer"
        :color="mode === 'tile' ? '#3A405A' : '#BDC1D4'"
        @click="changeMode('tile')"
      />
      <p-icon-blocks
        class="w-5 h-5 cursor-pointer"
        :color="mode === 'simple' ? '#3A405A' : '#BDC1D4'"
        @click="changeMode('simple')"
      />
    </div>
  </div>
  <div class="relative lg:hidden">
    <div
      @click="isShowSort = !isShowSort"
      class="font-lato relative text-base flex flex-row space-x-2 items-center cursor-pointer"
      :class="isShowSort ? 'text-secondary-200' : 'text-primary-200'"
    >
      <p class="">{{ selectValue.name }}</p>
      <p-icon-arrow
        class="w-3 h-3"
        :isOpen="isShowSort"
        :color="isShowSort ? '#FFA267' : '#656F9C'"
      ></p-icon-arrow>
    </div>
    <p-dropdown-wrapper
      v-if="isShowSort"
      ref="refDropdown"
      class="absolute top-8 left-0 rounded-lg !w-50 right-0 z-40"
    >
      <ul
        v-for="option in sortOptions"
        key="option.name"
        class="mb-2 last:mb-0"
      >
        <li class="flex items-center whitespace-nowrap space-x-2">
          <input
            type="radio"
            class="cursor-pointer accent-[#3a405a]"
            :id="option.sort"
            :value="option"
            v-model="selectValue"
          />
          <label
            @click="selectValue = option"
            class="cursor-pointer font-lato text-sm text-gray-700"
            >{{ option.name }}</label
          >
        </li>
      </ul>
    </p-dropdown-wrapper>
  </div>
</template>
